import type {ComponentProps, PartData} from '@enonic/react-components';
import React from 'react';
import Enonicarousel, {type EnonicarouselProps} from '../components/Enonicarousel';


export interface PromotionBannerProps
	extends Record<string, unknown> {
	carousel: EnonicarouselProps
}


export function PromotionBanner({data}: ComponentProps<PartData>) {
	const {
		carousel,
	} = data as PromotionBannerProps;

	return (
		<div className='promotion-banner'>
			<Enonicarousel {...carousel} />
		</div>
	);
}
